import { emitAnalyticsEvent, emitConfirmedLead, type AnalyticsParams } from "@/lib/analytics-events";

/**
 * Conversion events for the AI-kollen landing page. The page is measured on
 * two numbers: share of visitors who book (`ai_kollen_booked`) and share who
 * leave an email (`ai_kollen_email`). Events go to the GTM data layer and to
 * GA4 through the shared consent-gated sender. UTM extraction below is used
 * only for the contact backend, never for arbitrary analytics parameters.
 */
export type AiKollenEvent = "ai_kollen_cta" | "ai_kollen_booked" | "ai_kollen_email";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const;

export function readAiKollenUtm(): Record<string, string> {
  const params = new URLSearchParams(window.location.search);
  const utm: Record<string, string> = {};
  for (const key of UTM_KEYS) {
    const value = params.get(key)?.trim();
    if (value) utm[key] = value.slice(0, 200);
  }
  return utm;
}

/** Preserve outreach hooks, but never queue events before consent or on staging. */
export function trackAiKollenEvent(event: AiKollenEvent, params: AnalyticsParams = {}): void {
  if (event === "ai_kollen_email") {
    emitConfirmedLead({ form_id: "ai_kollen_email", method: "contact_form" }, event);
    return;
  }
  emitAnalyticsEvent(event, params);
}
